import React, {useEffect, useRef, useState} from 'react';
import './sd.scss';
import {ArrowBack} from '@mui/icons-material';
import Fab from '@mui/material/Fab';
import {Search, ArrowDown} from '../../../assets/icons/component';
import {SolicTable} from './SolicTable.js';
import {useNavigate} from 'react-router-dom';
import {AppRoutes} from "../../../Router";
import { WLOCreditAPIService } from '../../../services';
import {WloCreditoService} from '../../../types';
import ClockLoader from 'react-spinners/ClockLoader';

const isoFromDate = (date: Date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
};

const defaultRange = () => {
    const fin = new Date();
    const ini = new Date();
    ini.setDate(fin.getDate() - 30);
    return { ini: isoFromDate(ini), fin: isoFromDate(fin) };
};

const toWsDate = (iso: string) => {
    const [year, month, day] = iso.split('-');
    return `${month}/${day}/${year}`;
};

const Options = [
    {
        option: 'Cliente'
    },
    {
        option: 'Ciudad'
    },
    {
        option: 'Estado Firma'
    },
    {
        option: 'Estado Credito'
    },
    {
        option: 'Linea de Credito'
    }
]

interface OptionProps {
    Options: {
        option: string
    }[];
    bg: string;
    clr: string;
    str: string;
}

export const Select: React.FC <OptionProps> = ({Options,bg,clr,str}) => {
    return(
        <li>
            <ArrowDown stroke={str} />
            <select name="search" id="search" style={{background:bg,color:clr}}>
                {
                    Options.map((option,i)=>{
                        return(
                            <option key={i} value={option.option}>{option.option}</option>
                        )
                    })
                }
            </select>
        </li>
    )
}
export const Select2: React.FC <OptionProps> = ({Options,bg,clr,str}) => {
    return(
        <>
            <ArrowDown stroke={str} />
            <select name="search" id="search" style={{background:bg,color:clr}}>
                {
                    Options.map((option,i)=>{
                        return(
                            <option key={i} value={option.option}>{option.option}</option>
                        )
                    })
                }
            </select>
        </>
    )
}

export const SolicDocument: React.FC = () => {
    const navigate = useNavigate();
    const textInputRef = useRef<HTMLInputElement>(null);
    const rangoInicial = defaultRange();
    const [table,setTable]= useState<any[]>([])
    const [table2,setTable2]= useState<any[]>([])
    const [fechaIni, setFechaIni] = useState(rangoInicial.ini);
    const [fechaFin, setFechaFin] = useState(rangoInicial.fin);
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = (event: React.FormEvent) => {
        const select = document.getElementById('search') as HTMLSelectElement | null;

        event.preventDefault();
        let enteredText = textInputRef.current!.value;
        if(table.length>0){
            if(select?.value==="Cliente"){
                const tablaIngr= table.filter((valor:any)=>{
                    if((valor.Pws_Nombres.toUpperCase()).includes(enteredText.toUpperCase())){
                        return true
                    }else{
                        return false
                    }
                })
                setTable2(tablaIngr)
            }else if(select?.value==="Ciudad"){
                const tablaIngr= table.filter((valor:any)=>{
                    if((valor.Pws_ciudad.toUpperCase()).includes(enteredText.toUpperCase())){
                        return true
                    }else{
                        return false
                    }
                })
                setTable2(tablaIngr)
            }else if(select?.value==="Estado Firma"){
                const tablaIngr= table.filter((valor:any)=>{
                    if((valor.Pws_Estado_Firma.toUpperCase()).includes(enteredText.toUpperCase())){
                        return true
                    }else{
                        return false
                    }
                })
                setTable2(tablaIngr)
            }else if(select?.value==="Estado Credito"){
                const tablaIngr= table.filter((valor:any)=>{
                    if((valor.Pws_Estado_credito.toUpperCase()).includes(enteredText.toUpperCase())){
                        return true
                    }else{
                        return false
                    }
                })
                setTable2(tablaIngr)
            }else if(select?.value==="Linea de Credito"){
                const tablaIngr= table.filter((valor:any)=>{
                    if((valor.Pws_Lincre.toUpperCase()).includes(enteredText.toUpperCase())){
                        return true
                    }else{
                        return false
                    }
                })
                setTable2(tablaIngr)
            }
        }
    }

    const consultarListado = (iniIso: string, finIso: string) => {
        const rango = defaultRange();
        const inicio = iniIso || rango.ini;
        const fin = finIso || rango.fin;
        setIsLoading(true);
        const valoragregado: WloCreditoService.SolicitudListadoRequest = {
            Pws_num_solicitud: '',
            Pws_fec_solicitud_ini: toWsDate(inicio),
            Pws_fec_solicitud_fin: toWsDate(fin),
            Pws_Tip_estado: '',
            Pws_Tip_Consulta: '1',
        };
        WLOCreditAPIService.consultaSolicitudListadoCygnus(valoragregado).then((consulta) => {
            const raw = consulta?.payload?.data?.datos_soli?.datos_Sol;
            const rows = Array.isArray(raw) ? raw : raw ? [raw] : [];
            setTable(rows);
            setTable2(rows);
            setIsLoading(false);
        }, (error) => {
            console.log(error);
            setTable([]);
            setTable2([]);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        consultarListado(fechaIni, fechaFin);
        // La carga inicial usa el rango de los últimos 30 días.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const functionss = () => {
        consultarListado(fechaIni, fechaFin);
    };

    const aplicarRango = (event: React.MouseEvent) => {
        event.preventDefault();
        consultarListado(fechaIni, fechaFin);
    };
    
    return (
    <div className="solicDoc">
        <ClockLoader id="spinner" color="#4FAE32" loading={isLoading} size={100} />
        <Fab variant="extended" color="neutral" aria-label="add"
                        onClick={()=>{
                            navigate(AppRoutes.MENU_USER, {replace: true});
                        }} style={{float:"left"}} className="hooverButtonRed">
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {'Atrás'}
                    </Fab>
        <div className="solicDocument">
            <h4>Solicitudes de crédito</h4>
            <div className="solicTable">
                <div className="search">
                    <form action="" method="post" onSubmit={handleSubmit}>
                        <Select Options={Options} bg={`#4A4A4A`} clr={`#fff`} str={`#fff`} />
                        <div className="date-filter">
                            <h5>Rango de fechas</h5>
                            <div className="rango-fechas">
                                <input
                                    type="date"
                                    value={fechaIni}
                                    max={fechaFin || undefined}
                                    onChange={(event) => setFechaIni(event.target.value)}
                                />
                                <input
                                    type="date"
                                    value={fechaFin}
                                    min={fechaIni || undefined}
                                    onChange={(event) => setFechaFin(event.target.value)}
                                />
                            </div>
                            <button type="button" onClick={aplicarRango}>Aplicar filtro</button>
                        </div>
                        <li>
                            <div onClick={handleSubmit}>
                            <Search  />
                            </div>
                            <input type="text" name="seacrh" placeholder="search" ref={textInputRef}/>
                        </li>
                    </form>
                </div>
                <div className="table">
                    <SolicTable value={{tablasva:table2,functionss}} />
                </div>
            </div>
        </div>
    </div>
  )
}
